import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';
import Header from '../../features/Header';
import Footer from '../../features/Footer';

const PatientDashboard = React.lazy(() =>
  import('../../views/PatientDashboard')
);

const params = [];

const PatientDashboardRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<Header />} footer={<Footer />}>
        <PatientDashboard />
      </Layout>
    </RouteParameter>
  );
};

PatientDashboardRoute.propTypes = {};

PatientDashboardRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(PatientDashboardRoute);
